import { PRODUCT_FEATURE_CAPABILITY } from "utils/constants/capability";

export const UPGRADE_REMOVE_BRANDING_PROMPT = {
  uid: PRODUCT_FEATURE_CAPABILITY.REMOVE_BRANDING,
  icon: "magic",
  header: "Custom branding",
  subheader:
    "Replace PriceBlocs branding in Checkout with your own branding when you upgrade to a paid account."
};

export const UPGRADE_ATTACH_FILES_PROMPT = {
  uid: PRODUCT_FEATURE_CAPABILITY.ATTACH_FILES,
  icon: "magic",
  header: "Sell your content",
  subheader:
    "Upgrade to a premium plan and we'll send your customer a secure download link for any files attached to a payment link, after a successful payment."
};

export const UPGRADE_TRANSACTION_FEE_PROMPT = {
  uid: PRODUCT_FEATURE_CAPABILITY.TRANSACTION_FEE,
  icon: "magic",
  header: "Lower fees",
  subheader: ({ value }) =>
    `Upgrade to get ${value} transaction fees from PriceBlocs on page checkouts.`
};

export const UPGRADE_FEATURE_PROMPT_MAP = {
  [PRODUCT_FEATURE_CAPABILITY.ATTACH_FILES]: UPGRADE_ATTACH_FILES_PROMPT,
  [PRODUCT_FEATURE_CAPABILITY.REMOVE_BRANDING]: UPGRADE_REMOVE_BRANDING_PROMPT,
  [PRODUCT_FEATURE_CAPABILITY.TRANSACTION_FEE]: UPGRADE_TRANSACTION_FEE_PROMPT
};
